import CheckBoxAnswer from '@/components/shared/answer-types/checkbox/checkbox.vue';
import { YES_NO_OPTIONS } from '../../constants/club-registration-constants.js';

export default {
    name: 'ReviewSubmitSection',

    components: {
        'checkbox-answer': CheckBoxAnswer
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        assignedMembershipTypes: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            acceptTermsOptions: YES_NO_OPTIONS,
            termsLinkClicked: false
        };
    },

    computed: {
        canAcceptTerms() {
            return this.termsLinkClicked;
        },
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        },
        localValidation: {
            get() { return this.validation; },
            set(value) { this.$emit('update:validation', value); }
        }
    },

    methods: {
        onTermsLinkClick() {
            this.termsLinkClicked = true;
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/review-submit-section/review-submit-section.js